var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18,
    y1: 36,
    x2: 18,
    y2: -0.00001537983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#009245"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9E021"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M35.1,0.9C34.6,0.3,33.8,0,33,0H3C2.2,0,1.4,0.3,0.9,0.9C0.3,1.4,0,2.2,0,3v30 c0,0.8,0.3,1.6,0.9,2.1C1.4,35.7,2.2,36,3,36h30c1.6,0,3-1.4,3-3V3C36,2.2,35.7,1.4,35.1,0.9z M33,33H3V3h30V33z M18,23.8 c-0.8,0-1.4-0.6-1.4-1.4c0-2.6,1.2-4.9,3.4-6.6c0.9-0.7,1.4-1.7,1.4-2.8c0-1.8-1.5-3.2-3.3-3.3c-0.9,0-1.8,0.3-2.5,1 c-0.7,0.6-1,1.5-1,2.4c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4c0-1.7,0.7-3.3,1.9-4.4c1.2-1.2,2.8-1.8,4.5-1.7c3.2,0.1,5.9,2.8,6,6 c0.1,2-0.9,3.9-2.5,5.1c-1.5,1.1-2.3,2.7-2.3,4.3C19.4,23.2,18.8,23.8,18,23.8z M19.6,27.5c0-0.9-0.7-1.6-1.6-1.6s-1.6,0.7-1.6,1.6 c0,0.9,0.7,1.6,1.6,1.6S19.6,28.4,19.6,27.5z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpGreen);
export default __webpack_public_path__ + "static/media/help_green.4fbba78a63133041706f4d564eb1aabe.svg";
export { ForwardRef as ReactComponent };